import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4 text-center">
      <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
      <h2 className="text-xl font-semibold text-foreground mb-2">الصفحة غير موجودة</h2>
      <p className="text-muted-foreground mb-6">عذراً، الصفحة التي تبحث عنها غير موجودة</p>
      <Link to="/">
        <Button>
          <Home className="w-4 h-4 ml-2" />
          العودة للرئيسية
        </Button>
      </Link>
    </div>
  );
};

export default NotFound;
